import {GET_CURRENT_QUESTION_START, GET_CURRENT_QUESTION_SUCCESS, GET_CURRENT_QUESTION_FAIL, GET_CURRENT_QUESTION_RESET} from './constants';
import {GetCurrentQuestionActions, GetCurrentQuestionState} from './types';

const initialState: GetCurrentQuestionState = {
  loading: false,
  data: undefined,
  error: undefined,
};

const reducer = (
  state = initialState,
  action: GetCurrentQuestionActions,
): GetCurrentQuestionState => {
  switch (action.type) {
    case GET_CURRENT_QUESTION_START:
      return {
        ...initialState,
        loading: true,
      };
    case GET_CURRENT_QUESTION_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case GET_CURRENT_QUESTION_FAIL:
     return {
        ...state,
        loading: false,
        error: action.error,
      };
    case GET_CURRENT_QUESTION_RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducer;
